import { Controller } from "@hotwired/stimulus"
import i18n from "../javascripts/util/i18n"

// Server-search-backed variables drag panel (shares /variables/search with the @-prompt).
export default class extends Controller {
  static targets = [ "filter", "query", "list" ]
  static values = { url: String }

  connect() {
    this.debounceTimer = null
    this.fetchResults()
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
  }

  reloadNow() {
    clearTimeout(this.debounceTimer)
    this.fetchResults()
  }

  reloadDebounced() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.fetchResults(), 200)
  }

  async fetchResults() {
    if (!this.urlValue) {
      return
    }
    const scope = this.hasFilterTarget ? this.filterTarget.value : "current"
    const query = this.hasQueryTarget ? this.queryTarget.value : ""
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("scope", scope)
    url.searchParams.set("filter", query)

    // Guard against out-of-order responses.
    const token = Symbol("fetch")
    this.fetchToken = token
    try {
      const response = await fetch(url, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      if (!response.ok || this.fetchToken !== token) {
        return
      }
      const html = (await response.text()).trim()
      if (this.fetchToken !== token || !this.hasListTarget) {
        return
      }
      this.listTarget.innerHTML = html || `<span class="text-xs text-gray-400">${i18n.t("js.variable_panel.empty")}</span>`
    } catch (_error) {
      // Keep the current list on transient errors.
    }
  }
}
